<template>
  <div>
    <Breadcrumbs main="Rutas" title="Vehículos"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
                <b-button variant="success" size="sm" :to="{name: 'RouteVehicleForm'}">
                  <i class="fa fa-map-marker"></i> Agregar vehículo
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue">
                <vdtnet-table
                        ref="table"
                        :fields="datatableConfig.fields"
                        :opts="datatableConfig.options"
                        @editObject="editObject"
                        @disableObject="disableObject">
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import $ from 'jquery';
  window.jQuery = $;
  import VdtnetTable from 'vue-datatables-net';
  import 'datatables.net-bs4';
  import utils from '../../../utils';
  import axios from "axios";
  export default {
    components: {
      VdtnetTable
    },
    data(){
      return{
        datatableConfig : {
          options: {
            lengthMenu: [10, 25, 50],
            pageLength: 10,
            lengthChange: false,
            processing: true,
            serverSide: true,
            searchDelay: 500,
            fixedHeader: true,
            responsive: true,
            ajax: {
              url: axios.defaults.baseURL + '/api/route/v1.0/vehicle/?format=datatables',
              type: "GET",
              headers: {
                Authorization: 'JWT ' + localStorage.getItem('token')
              },
              dataSrc: (json) => {
                return json['data'];
              }
            },
            language: {
              decimal: "",
              emptyTable: "No hay información",
              info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
              infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
              infoFiltered: "(Filtrado de _MAX_ total entradas)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ Entradas",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              zeroRecords: "Sin resultados encontrados",
              paginate: {
                first: "Primero",
                last: "Ultimo",
                next: "Siguiente",
                previous: "Anterior"
              }
            },
            "drawCallback": function () {
              // const num_row = $('.dataTables_length');
              $('div.vdtnet-container').removeClass('table-responsive');
              // num_row.find('select').removeClass('custom-select form-control');
              $('.dataTables_paginate').addClass('pull-right mt-2');
              $('.dataTables_info').addClass('mt-2');
            },
          },
          fields: {
            id: {
              data: 'id',
              visible: false,
              searchable: false,
            },
            patente: {
              name: 'patent',
              label: 'Patente',
              data: 'patent',
              sortable: true,
            },
            type: {
              name: 'type',
              label: 'Tipo de transporte',
              data: 'type',
              sortable: true,
              render: function (data, type, row) {
                return utils.statusVehicle.find(item => item['id'] === row['type'])['name'];
              }
            },
            available: {
              name: 'available',
              label: 'Estado',
              data: 'available',
              render: function (data, type, row) {
                let status;
                if(row['available']){
                  status = '<span class="badge badge-success">Disponbile</span>';
                }else{
                  status = '<span class="badge badge-danger">En uso</span>';
                }
                return status;
              }
            },
            actions: {
              label: 'Acciones',
              isLocal: true,
              render: function (data, type, row) {
                let status = '';
                // if(row['status']){
                //   status = '<a href="javascript:void(0);" data-action="disableObject" title="Deshabilitar"><span class="badge badge-warning"><i class="fa fa-times"></i></span></a>'
                // } else {
                //   status = '<a href="javascript:void(0);" data-action="disableObject" title="Habilitar"><span class="badge badge-success"><i class="fa fa-check"></i></span></a>'
                // }

                return '<a href="javascript:void(0);" data-action="editObject" title="Modificar"><span class="badge badge-primary"><i class="fa fa-pencil"></i></span></a> ' +
                    `${status}`;
              }
            }
          },
          quickSearch: '',
        }
      }
    },
    beforeDestroy () {
      clearInterval(this.intervalTable);
    },
    mounted() {
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
    },
    methods: {
      reloadTable() {
        // ELIMINAOS EL INTERVALO
        clearInterval(this.intervalTable);
        // RECARGAMOS
        this.$refs.table.reload();
        // GENERAMOS EL INTERVALO
        this.intervalTable = setInterval(() => {
          this.$refs.table.reload();
        }, utils.timeRefresh * 1000);
      },
      doSearch() {
        this.$refs.table.search(this.datatableConfig.quickSearch);
      },
      editObject(data){
        this.$router.push({'name': 'RouteVehicleFormEdit', params: { objectId: data['id'] }});
      },
      async disableObject(row){
        let oldState = '';
        let newState = '';

        if(row['status']){
          oldState = 'Habilitado';
          newState = 'Deshabilitado';
        } else {
          oldState = 'Deshabilitado';
          newState = 'Habilitado';
        }

        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>cambiar el estado</b> del vehiculo <b>${row['patent']}</b> de <b>${oldState}</b> a <b>${newState}</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/route/v1.0/vehicle/' + row['id'] + '/';
            let data = {status: !row['status']};
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if(response){
              await this.$swal({
                title: 'Editado!',
                type: 'success',
                html: `Se ha editado el estado del vehículo de manera correcta.`,
              });
              this.reloadTable();
            }
          }
        });
      },
    },
  }
</script>

<style>
  table img {
    width: 100px;
    height: 100px;
  }
</style>